import { anytimeLogoSvg } from "./logoSvg";

export function Logo({ className = "logo" }: { className?: string }) {
  return (
    <span
      className={className}
      role="img"
      aria-label="Anytime Fitness"
      dangerouslySetInnerHTML={{ __html: anytimeLogoSvg }}
    />
  );
}
